import { IoIosHelpCircleOutline } from 'react-icons/io';
import { formatCurrency } from '@/helpers/utils/siteUtils';
import { ORDER_TOTAL_DETAILS_HEADER, ORDER_TOTAL_DETAILS_KEYS } from '../../../customer-detail/constants';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../ui/customAccordian/customAccordian';
import { Table, TableColumnConfig } from '../../../ui/customTable/Table';

const OrderTotalDetails = ({ Texts, orderTotalDetails }: any) => {
  const TableHeader: TableColumnConfig<any>[] = [
    {
      key: ORDER_TOTAL_DETAILS_KEYS.HEADER,
      header: ORDER_TOTAL_DETAILS_HEADER.HEADER,
      render: (data, rowData) => (
        <div className={`${rowData?.isBold ? 'font-semibold' : ''} flex items-center font-normal text-black`}>
          {data} {rowData?.toolTipIcon ? <IoIosHelpCircleOutline className="ml-1 text-xl text-[#B6B6B8]" /> : <></>}
        </div>
      ),
    },
    {
      key: ORDER_TOTAL_DETAILS_KEYS.INVOICED,
      header: ORDER_TOTAL_DETAILS_HEADER.INVOICED,
      render: (data, rowData) => (
        <div className={`${rowData?.isBold ? 'font-semibold' : ''}`}>{formatCurrency(data.toString())}</div>
      ),
    },
    {
      key: ORDER_TOTAL_DETAILS_KEYS.BACKORDER,
      header: ORDER_TOTAL_DETAILS_HEADER.BACKORDER,
      render: (data, rowData) => (
        <div className={`${rowData?.isBold ? 'font-semibold' : ''}`}>{formatCurrency(data.toString())}</div>
      ),
    },
    {
      key: ORDER_TOTAL_DETAILS_KEYS.READY_TO_SHIP,
      header: ORDER_TOTAL_DETAILS_HEADER.READY_TO_SHIP,
      render: (data, rowData) => (
        <div className={`${rowData?.isBold ? 'font-semibold' : ''}`}>{formatCurrency(data.toString())}</div>
      ),
    },
    {
      key: ORDER_TOTAL_DETAILS_KEYS.EST_ORDER_TOTAL,
      header: ORDER_TOTAL_DETAILS_HEADER.EST_ORDER_TOTAL,
      render: (data, rowData) => (
        <div className={`${rowData?.isBold ? 'font-semibold' : ''}`}>{formatCurrency(data.toString())}</div>
      ),
    },
  ];

  return (
    <Accordion type="single" collapsible className="w-full rounded-md border border-foggyGray px-5 py-1 shadow-lg">
      <AccordionItem value="item-1" className="border-none">
        <AccordionTrigger className="text-lg font-bold hover:no-underline">{Texts.orderTotalDetails}</AccordionTrigger>
        <AccordionContent>
          <Table columns={TableHeader} data={orderTotalDetails} />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default OrderTotalDetails;
